function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h26v26H0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.433 8.334c-.05 1.007-.058 2.425-.083 2.74-.037.47-.116 1.008-.81 1.03-.642.022-1.602.05-2.88.086-.53-.05-1.015-.328-1.29-.795-.468-.796-.144-1.84.724-2.334.867-.493 1.95-.247 2.419.549.22.375.173.792.16 1.206l-.067 2.218c-.105.494-.385 1.263-1.195 1.287-.81.023-.32.004-2.082.016",
  stroke: "#371447"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.604 13.759h1.345c.681-2.077 1.711-3.375 4.067-3.966.007-.475-.01-2.163 0-2.414 1.913-.044 2.653.899 2.653 2.414 4.24.007 1.975-.058 5.04 0 3.066.057 5.49 2.059 5.752 5.34-.036 2.268-.546 4.182-3.776 5.436-.012-.02.006.144 0 1.484-.004.85-2.868.85-2.87 0V20.57h-2.817l.012 1.484c-.045.849-2.908.851-2.898 0V20.57c-2.446-.183-3.94-.94-4.72-2.842a87.89 87.89 0 01-1.53 0c-.817.102-1.232-.5-1.246-1.807-.013-1.308.316-2.028.988-2.161z",
  stroke: "#371447",
  fill: "#C0D0D8"
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#371447",
  cx: 5.893,
  cy: 13.921,
  r: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.419 4.472c.092-.202.143-.426.143-.662 0-.896-.739-1.623-1.65-1.623-.912 0-1.651.727-1.651 1.623 0 .84.648 1.53 1.48 1.613",
  stroke: "#371447"
}), /*#__PURE__*/React.createElement("ellipse", {
  stroke: "#371447",
  cx: 14.209,
  cy: 6.127,
  rx: 1.651,
  ry: 1.622
}));

function SvgCoreSavingsSm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgCoreSavingsSm;